var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLabel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 710.6 140.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#17ff39;}.cls-3{fill:#f8ff2e;}.cls-4{fill:#f70006;}.cls-5{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:13px;}.cls-6{font-size:60px;font-family:Moby-Bold, Moby;font-weight:700;}.cls-7{font-size:130px;font-family:Moby-Regular, Moby;letter-spacing:-0.1em;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo label") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 162.13,
    height: 130.89,
    rx: 15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.98,
    y: 20.01,
    width: 136.17,
    height: 97.86,
    rx: 7.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 48.11,
    cy: 10.69,
    r: 5.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 33.06,
    cy: 10.69,
    r: 5.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 18.01,
    cy: 10.69,
    r: 5.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 65.45,
    y1: 94.66,
    x2: 96.68,
    y2: 94.66
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "31.17 43.21 56.96 69 31.3 94.66"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "130.96 43.21 105.17 69 130.83 94.66"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_4"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(469.88 110.87)"
  }, "."), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(162.13 110.95)"
  }, "4sudo"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLabel);
export default __webpack_public_path__ + "static/media/logo_label.8595de20.svg";
export { ForwardRef as ReactComponent };